import $ from 'jquery';
import _ from 'underscore'
import TextEditable from "./modules/text.editable";
import TextAreaEditable from "./modules/textarea.editable";
import SelectEditable from "./modules/select.editable";

/*
 * Jeditable - jQuery in place edit plugin
 *
 * Copyright (c) 2006-2009 Mika Tuupola, Dylan Verheul
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * Project home:
 *   http://www.appelsiini.net/projects/jeditable
 *
 * Based on editable by Dylan Verheul <dylan_at_dyve.net>:
 *    http://www.dyve.net/jquery/?editable
 *
 */

function addPlaceholder(elAd, settings) {
    const el = elAd.element;
    if ($(el).prop("tagName").toLowerCase() === "iframe" && elAd.text.trim() === "")
        $(el).before(settings.placeholder);
    else if (!$.trim(elAd.html))
        elAd.html = settings.placeholder;
}


class ElementAdapter {
    constructor(el) {
        const $el = $(el);
        this.element = el;
        if ($el.prop("tagName").toLowerCase() === "iframe") {
            const doc = $el.contents().get(0);
            this.getText = () => doc.documentElement.textContent;
            this.setText = t => doc.documentElement.textContent = t;
            this.getHtml = () => doc.documentElement.outerHTML;
            this.setHtml = h => {
                doc.innerHTML = "";
                doc.open();
                doc.write(h);
                doc.close();
            };
        } else {
            this.getText = () => $el.text();
            this.setText = t => $el.text(t);
            this.getHtml = () => $el.html();
            this.setHtml = h => $el.html(h);
        }
    }

    get text() {
        return this.getText();
    }

    get html() {
        return this.getHtml();
    }

    set text(txt) {
        this.setText(txt);
    }

    set html(html) {
        this.setHtml(html);
    }
}

/**
 * Version 1.7.1
 *
 * ** means there is basic unit tests for this parameter.
 *
 * @name  Jeditable
 * @type  jQuery
 * @param {string}  target             (POST) URL or function to send edited content to **
 * @param {object}    options            additional options
 * @param {string}  options.method    method to use to send edited content (POST or PUT) **
 * @param {function} options.callback Function to run after submitting edited content **
 * @param {string}  options.name      POST parameter name of edited content
 * @param {string}  options.id        POST parameter name of edited div id
 * @param {hash}    options.submitdata Extra parameters to send when submitting edited content.
 * @param {string}  options.type      text, textarea or select (or any 3rd party input type) **
 * @param {integer} options.rows      number of rows if using textarea **
 * @param {integer} options.cols      number of columns if using textarea **
 * @param {mixed}   options.height    'auto', 'none' or height in pixels **
 * @param {mixed}   options.width     'auto', 'none' or width in pixels **
 * @param {string}  options.loadurl   URL to fetch input content before editing **
 * @param {string}  options.loadtype  Request type for load url. Should be GET or POST.
 * @param {string}  options.loadtext  Text to display while loading external content.
 * @param {mixed}   options.loaddata  Extra parameters to pass when fetching content before editing.
 * @param {mixed}   options.data      Or content given as paramameter. String or function.**
 * @param {string}  options.indicator indicator html to show when saving
 * @param {string}  options.tooltip   optional tooltip text via title attribute **
 * @param {string}  options.event     jQuery event such as 'click' of 'dblclick' **
 * @param {string}  options.submit    submit button value, empty means no button **
 * @param {string}  options.cancel    cancel button value, empty means no button **
 * @param {string}  options.cssclass  CSS class to apply to input form. 'inherit' to copy from parent. **
 * @param {string}  options.style     Style to apply to input form 'inherit' to copy from parent. **
 * @param {string}  options.select    true or false, when true text is highlighted ??
 * @param {string}  options.placeholder Placeholder text or html to insert when element is empty. **
 * @param {string}  options.projectionElement Element that is used to project complex things such as whole html documents. **
 * @param {string}  options.onblur    'cancel', 'submit', 'ignore' or function ??
 *
 * @param {Function} options.onsubmit function(settings, original) { ... } called before submit
 * @param {Function} options.onreset  function(settings, original) { ... } called before reset
 * @param {Function} options.onerror  function(settings, original, xhr) { ... } called on error
 *
 * @param {hash}    options.ajaxoptions  jQuery Ajax options. See docs.jquery.com.
 *
 */
$.fn.editable = function (target, options) {

    if ('disable' === target) {
        return $(this).data('disabled.editable', true);
    }
    if ('enable' === target) {
        return $(this).data('disabled.editable', false);
    }
    if ('destroy' === target) {
        return $(this)
            .unbind($(this).data('event.editable'))
            .removeData('disabled.editable')
            .removeData('event.editable');
    }

    const editable = new JEditable(target, options);
    const settings = editable.settings;

    /* show tooltip */
    if (settings.tooltip) {
        $(this).attr('title', settings.tooltip);
    }

    settings.autowidth = 'auto' === settings.width;
    settings.autoheight = 'auto' === settings.height;

    return this.each((i,el)=>editable.iteratee(el, editable));

};

class JEditable {

    static defaults = {
        name: 'value',
        id: 'id',
        type: 'text',
        width: 'auto',
        height: 'auto',
        event: 'click.editable',
        onblur: 'cancel',
        loadtype: 'GET',
        loadtext: 'Loading...',
        placeholder: 'Click to edit',
        loaddata: {},
        submitdata: {},
        ajaxoptions: {}
    };

    static types = {
        text: TextEditable,
        textarea: TextAreaEditable,
        select: SelectEditable
    };

    static addInputType(name, input) {
        JEditable.types[name] = input;
    }

    constructor(target, options) {
        const settings = Object.assign({}, JEditable.defaults, {target}, options);
        this.settings = settings;

        /* setup some functions */
        const type = new JEditable.types[settings.type]();
        const plugin = type.plugin || _.noop;
        const submit = type.submit || _.noop;
        const buttons = type.buttons || _.noop;
        const content = type.content || _.noop;
        const element = type.element || _.noop;
        const reset = type.reset || _.noop;
        const callback = settings.callback || _.noop;
        const onedit = settings.onedit || _.noop;
        const onsubmit = settings.onsubmit || _.noop;
        const oncancel = settings.oncancel || _.noop;
        const onreset = settings.onreset || _.noop;
        const onerror = settings.onerror || reset;

        this.helpers = {
            plugin,
            submit,
            buttons,
            content,
            element,
            reset,
            callback,
            onedit,
            onsubmit,
            oncancel,
            onreset,
            onerror
        };
    }

    iteratee(edEl, editable) {

        const {oncancel, onreset} = editable.helpers;
        const settings = editable.settings;

        const el = settings.projectionElement || edEl;
        const elAdapter = new ElementAdapter(el);

        /* save so it can be later used by JEditable('destroy') */
        const $edEl = $(edEl);
        $edEl.data('event.editable', settings.event);

        /* if element is empty add something clickable (if requested) */
        addPlaceholder(elAdapter, settings);

        $edEl.bind(settings.event, _.partial(editable.eventHandler, edEl, editable, elAdapter));

        /* privileged methods */
        edEl.reset = form => {
            /* prevent calling reset twice when blurring */
            if (edEl.editing) {
                /* before reset hook, if it returns false abort reseting */
                var shouldResetForm = onreset.apply(form, [settings, edEl]);

                if (!shouldResetForm) {
                    elAdapter.html = edEl.revert;
                    edEl.editing = false;
                    form.remove();
                    addPlaceholder(elAdapter, settings);
                    /* show tooltip again */
                    if (settings.tooltip) {
                        $edEl.attr('title', settings.tooltip);
                    }
                    $edEl.removeClass('editing');
                }
            }
        };

        edEl.cancelsubmit = form => {
            oncancel.apply(form, [settings, edEl]);
            $('#sender-name-error-message').hide();
        };
    }

    eventHandler(edEl, editable, elAdapter, e) {

        const {plugin, buttons, content, element, reset, onedit} = editable.helpers;
        const settings = editable.settings;

        /* abort if disabled for this element */
        /* prevent throwing an exeption if edit field is clicked again */
        /* abort if onedit hook returns false */
        const $edEl = $(edEl);
        if (true === $edEl.data('disabled.editable')
            || edEl.editing
            || false === onedit.apply(edEl, [settings, edEl]))
            return;

        /* prevent default action and bubbling */
        e.preventDefault();
        e.stopPropagation();

        /* remove tooltip */
        if (settings.tooltip) {
            $edEl.removeAttr('title');
        }
        $edEl.addClass('editing');

        const boundSetDimension = _.partial(JEditable.setDimension, $edEl, settings);
        boundSetDimension("width");
        boundSetDimension("height");

        JEditable.findAndRemovePlaceHolder(settings, $edEl);

        edEl.editing = true;
        edEl.revert = elAdapter.html;
        elAdapter.html = "";

        /* create the form object */
        const form = $('<form />');

        JEditable.stylize(settings, form, $edEl);

        /* add main input element to form and store it in input */
        const input = element.apply(form, [settings, edEl]);

        /* set input content via POST, GET, given data or existing value */
        let inputContent = editable.getInputContent(edEl, settings, input, content, form);

        inputContent.then(data => content.apply(form, [data, settings, edEl]));

        input.attr('name', settings.name);

        /* add buttons to the form */
        buttons.apply(form, [settings, edEl]);

        /* add created form to self */
        $edEl.append(form);

        /* attach 3rd party plugin if requested */
        plugin.apply(form, [settings, edEl]);

        /* focus to first visible form element */
        $(':input:visible:enabled:first', form).focus();

        /* highlight input contents when requested */
        if (settings.select) input.select();

        if (settings.type !== "wysiwyg") $(input).filter('textarea')
            .each((i, el) => el.setAttribute('style', `height:${el.scrollHeight}px;overflow-y:hidden;`))
            .on('input', ({currentTarget: el}) => el.style.height = `${el.scrollHeight}px`);

        /* discard changes if pressing esc */
        input.keydown(e => {
            if (e.keyCode === 27) {
                e.preventDefault();
                //self.reset();
                reset.apply(form, [settings, edEl]);
            }
        });

        editable.handleBlur(edEl, settings, input, reset, form);

        form.submit(_.partial(editable.submitHandler, edEl, editable, elAdapter, form, input));
    }

    static findAndRemovePlaceHolder(settings, jqEl) {
        /* remove placeholder text */
        const $ph = $(settings.placeholder);

        let $phEl = /<\w+>/.test(settings.placeholder) ?
            jqEl.find(`:contains(${$ph.text()})`)
                .closest($ph.prop("tagName"))
            : jqEl.find(`:contains(${settings.placeholder})`)
                .contents()
                .filter((index, element) => element.nodeType === 3);
        $phEl.remove();
    }

    static stylize(settings, form, jqEl) {
        /* apply css or style or both */
        if (settings.cssclass)
            form.addClass('inherit' === settings.cssclass ? jqEl.attr('class') : settings.cssclass);

        if (settings.style)
            if ('inherit' === settings.style)
                form.attr('style', jqEl.attr('style'))
                    .css('display', jqEl.css('display'));
            else form.attr('style', settings.style);
    }

    static setDimension(jqEl, settings, dimension) {
        if (settings[dimension] !== 'none') {
            settings[dimension] =
                settings[`auto${dimension}`] ? jqEl[dimension]() : settings[dimension];
        }
    }

    handleBlur(edEl, settings, input, reset, form) {
        /* discard, submit or nothing with changes when clicking outside */
        /* do nothing is usable when navigating with tab */
        if ('cancel' === settings.onblur) {
            input.blur(e => {
                /* prevent canceling if submit was clicked */
                this.t = setTimeout(() => {
                    reset.apply(form, [settings, edEl]);
                }, 500);
            });
        } else if ('submit' === settings.onblur) {
            input.blur(e => {
                /* prevent double submit if submit was clicked */
                this.t = setTimeout(() => {
                    form.submit();
                }, 200);
            });
        } else if (_.isFunction(settings.onblur))
            input.blur(e => settings.onblur.apply(edEl, [input.val(), settings]));
        else {
            input.blur(e => {
                /* TODO: maybe something here */
            });
        }
    }

    async getInputContent(edEl, settings, input, content, form) {

        if (settings.loadurl) {
            this.t = setTimeout(() => {
                input.disabled = true;
                content.apply(form, [settings.loadtext, settings, edEl]);
            }, 100);

            const data = _.isFunction(settings.loaddata)
                ? settings.loaddata.apply(edEl, [edEl.revert, settings])
                : settings.loaddata;

            const loaddata = Object.assign({[settings.id]: edEl.id}, data);

            try {
                const result = await $.ajax({
                    type: settings.loadtype,
                    url: settings.loadurl,
                    data: loaddata
                });

                window.clearTimeout(this.t);
                input.disabled = false;
                return result;
            } catch (e) {
                console.error("Failed to load content.");
                return null;
            }
        } else if (settings.data) {
            if (_.isFunction(settings.data)) {
                return settings.data.apply(edEl, [edEl.revert, settings]);
            }
            return settings.data;
        } else {
            return edEl.revert;
        }
    }

    submitHandler(edEl, editable, elAdapter, form, input,e) {

        const {submit, callback, onsubmit, onerror} = editable.helpers;
        const settings = editable.settings;

            if (editable.t) clearTimeout(editable.t);
            /* do no submit */
            e.preventDefault();

            /* call before submit hook. */
            /* if it returns false abort submitting */
            var eventOnSubmit = onsubmit.apply(form, [settings, edEl]);
            var eventSubmit = submit.apply(form, [settings, edEl]);

            if (!eventOnSubmit && !eventSubmit) {

                /* check if given target is function */
                if (_.isFunction(settings.target)) {
                    const str = settings.target.apply(edEl, [input.val(), settings]) || input.val();
                    if (e === form)
                        elAdapter.text = str; //ds: prevent HTML or script injection
                    else
                        elAdapter.html = str; //submit has cleaned any xss attempt

                    edEl.editing = false;
                    /* show tooltip again */
                    $(edEl).attr('title', settings.tooltip);
                    $(edEl).removeClass('editing');

                    callback.apply(edEl, [elAdapter.html, settings]);
                    form.remove();
                    addPlaceholder(elAdapter, settings);
                } else {
                    /* add edited content and id of edited element to POST */
                    const submitdata = {};
                    submitdata[settings.name] = input.val();
                    submitdata[settings.id] = edEl.id;
                    /* add extra data to be POST:ed */
                    if (_.isFunction(settings.submitdata)) {
                        $.extend(submitdata, settings.submitdata.apply(edEl, [edEl.revert, settings]));
                    } else {
                        $.extend(submitdata, settings.submitdata);
                    }

                    /* quick and dirty PUT support */
                    if ('PUT' === settings.method) {
                        submitdata['_method'] = 'put';
                    }

                    /* show the saving indicator */
                    $(edEl).html(settings.indicator);

                    /* defaults for ajaxoptions */
                    const ajaxoptions = {
                        type: 'POST',
                        data: submitdata,
                        dataType: 'html',
                        url: settings.target,
                        success: (result, status) => {
                            if (ajaxoptions.dataType === 'html') {
                                $(edEl).html(result);
                            }
                            edEl.editing = false;

                            /* show tooltip again */
                            $(edEl).attr('title', settings.tooltip);
                            $(edEl).removeClass('editing');
                            callback.apply(edEl, [result, settings]);
                            addPlaceholder(elAdapter, settings);
                        },
                        error: (xhr, status, error) => {
                            onerror.apply(form, [settings, edEl, xhr]);
                        }
                    };

                    /* override with what is given in settings.ajaxoptions */
                    $.extend(ajaxoptions, settings.ajaxoptions);
                    $.ajax(ajaxoptions);

                }
            }

            return false;
    }
}

// publicly accessible defaults

export default JEditable;